import React from "react";

import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HelperText from "../HelperText";
import { theme } from "../../themes/GeneralTheme";

interface IFeesFormikWrapped {
  className?: string;
  symbol?: string;
  fee?: number;
  networkFee?: number;
  feeSymbol?: string;
  amountFormikName: string;
  error?: string;
}

type Values = {
  token: string;
  tokenAmount: string;
  receiver: string;
  feeCheck: string; // dummy for error handling
};

const outlinedError = {
  "&.error": {
    borderRadius: 4,
    transiton: "all 2s ease-in-out",
    padding: "8px 8px",
    margin: "-8px -10px",
    border: `3px solid ${theme.palette.error.main}`,
  },
};

const FeesFormikWrapped: React.FC<IFeesFormikWrapped> = ({
  symbol,
  fee,
  networkFee,
  feeSymbol,
  amountFormikName,
  error
}: IFeesFormikWrapped) => {
  const { values }: { values: Values } = useFormikContext();
  const theme = useTheme();
  const amountCost = Number(values[amountFormikName]);
  const transferAmount = isNaN(amountCost) ? "0" : amountCost.toFixed(3);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      mb="30px"
      flexDirection="column"
    >
      {fee !== undefined && feeSymbol !== undefined && (
        <Box display="flex" justifyContent="space-between" mb={4}>
          <Typography
            variant="body1"
            fontWeight={700}
            color={theme.palette.text.primary}
          >
            Transaction Fee
          </Typography>
          <Box display="flex" flexDirection={"column"} alignItems={"flex-end"}>
            <Typography
              variant="body1"
              fontWeight={700}
              color={theme.palette.text.primary}
              sx={outlinedError} className={error ? "error" : ""}
            >
              Network fees{networkFee ? ` (≈ ${networkFee})`:''} + {fee} {feeSymbol}
            </Typography>
            {error && <HelperText error={error} />}
          </Box>
        </Box>
      )}
      {symbol !== undefined && (
        <Box display="flex" justifyContent="space-between">
          <Typography
            variant="body1"
            fontWeight={700}
            color={theme.palette.text.primary}
          >
            Transfer Amount:
          </Typography>
          <Typography
            variant="body1"
            fontWeight={700}
            color={theme.palette.text.primary}
          >
            {transferAmount} {symbol}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FeesFormikWrapped;
